export default __webpack_public_path__ + "static/media/em_hat_2.357c25ca.jpg";